import React, { useState } from "react";
import { Link } from "react-router-dom";
import { getStudentIdData } from "../../../lib/studentcollegelist";
import { addData, deleteIdData } from "../../../lib/studentcollegelist";
import { getAllData } from "../../../lib/collegerank";
import { useAuth } from "../../../usercontext";
import GlobalCollegeList from "../../pages/common/globalcollegelist";
import S911TopMenu from "../../student911/topmenu/topmenu";

export default function StudentDesiredCollegeList() {
  const [collegelist, setCollegeList] = useState([]);
  const [studentCollegeList, setStudentCollegeList] = useState([]);
  const { profile } = useAuth();
  //const slug = "6cd022a6-81d9-4aba-8487-fd34f1ffd4c9";
  const slug = profile.id;
  const cls = profile.class;
const isStudent911 = profile?.role === "Student911"
  return (
    <>
      {isStudent911 && <S911TopMenu slug={slug} />}
      <GlobalCollegeList slug={slug} isStudent={true} />
    </>
  );
}
